import React, { ReactElement } from "react";
import { MessageContext } from "./MessageContext";
import Button from "@atlaskit/button/standard-button";
import Modal, {
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle,
    ModalTransition,
} from "@atlaskit/modal-dialog";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

export default function MessageModal({}: Props): ReactElement {
    const messageContext = React.useContext(MessageContext);
    return (
        <ModalTransition>
            {messageContext.state.isOpen && (
                <Modal onClose={messageContext.actions.closeModal}>
                    <ModalHeader>
                        <ModalTitle
                            appearance={messageContext.state.titleApparencce}
                        >
                            {messageContext.state.title}
                        </ModalTitle>
                    </ModalHeader>
                    <ModalBody>{messageContext.state.body}</ModalBody>
                    <ModalFooter>
                        {messageContext.state.buttons.map((button, index) => (
                            <Button
                                key={index}
                                appearance={button.buttonApperance}
                                onClick={button.onClick}
                            >
                                {button.buttonText}
                            </Button>
                        ))}
                    </ModalFooter>
                </Modal>
            )}
        </ModalTransition>
    );
}
